// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pLQkA3XM8K4j83OdlLy2{flex-direction:column;display:flex}.wY8zV8mKtkVEK0GuFhf0{flex-direction:column;gap:8px;margin-top:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pLQkA3XM8K4j83OdlLy2`,
	"list": `wY8zV8mKtkVEK0GuFhf0`
};
export default ___CSS_LOADER_EXPORT___;
